// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Barlow-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Barlow-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Nelphim.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/VisionMissionBG.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Barlow";
  src: local("Barlow"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
}

@font-face {
  font-family: "BarlowBold";
  src: local("BarlowBold"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
}

@font-face {
  font-family: "Nelphim";
  src: local("Nelphim"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
}

.section-about-group {
  display: block;
  max-width: 1366px;
  padding: 60px 0px;
  margin-left: auto;
  margin-right: auto;
}
.about-text {
  width: 100%;
  display: flex;
  padding-bottom: 60px;
}
.about-text .section-about-1 {
  width: 65%;
  padding: 0px 30px 0px 60px;
}
.about-text .section-about-2 {
  width: 35%;
  padding: 0px 60px 0px 30px;
}
.about-img {
  width: calc(100% - 120px);
  display: block;
  padding: 0px 60px 0px 60px;
  overflow: auto;
}
.about-img .about-img-group {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  overflow: auto;
}
.about-img .about-img-group img {
  width: 100%;
  border-radius: 30px;
  margin-bottom: 12px;
}

@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 100;
  }
}

.section-vision {
  background-color: #7ca7c1;
  width: 100vw;
  color: #fcfcfc;
 
}
.section-vision-group {
  display: flex;
  max-width: 1366px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: auto;
}
.vision-bg-image {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  min-height: 60vh;
  animation: fade-in 5s;
}
.section-vision-1 {
  height: 100%;
  width: 50%;
  display: block;
  text-align: right;
}
.section-vision-1 .section-title {
  margin-top: 90px;
  padding-right: 180px;
  text-transform: uppercase;
}
.section-vision-2 {
  width: 50%;
  display: block;
}
.section-vision-2 .section-detail {
  padding-left: 180px;
  padding-right: 60px;
  padding-top: 110px;
}
.section-vision-2 .section-button {
  padding-left: 180px;
}
.section-team {
  padding: 60px 0px;
}
.section-team-group {
  display: block;
  max-width: 1366px;
  margin-left: auto;
  margin-right: auto;
}
.section-team-title-group {
  width: 100%;
  display: flex;
  align-items: center;
}
.section-team-title-group .section-team-title {
  width: 50%;
  padding: 0px 0px 0px 60px;
}
.section-team-title-group .section-team-desc {
  width: 50%;
  padding: 0px 60px 0px 0px;
}
.section-team-image {
  display: flex;
  max-width: 1366px;
  margin-left: auto;
  margin-right: auto;
}
.team-image-group {
  width: calc(100% - 120px);
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 20px;
  overflow: auto;
  margin-left: auto;
  margin-right: auto;
  padding-top: 30px;
}
.team-image-group .card {
  width: 100%;
  display: block;
  margin-top: 30px;
}
.team-image-group .card .member-img-box {
  border-radius: 30px;
  background: #f7f7f7;
  display: flex;
  padding: 20px;
}
.team-image-group .card .member-img-box .member-img {
  width: 100%;
  border-radius: 30px;
}
.team-image-group .card .team-member-info {
  padding: 16px 20px 0px 20px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/style/about_web.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,4EAAwE;AAC1E;;AAEA;EACE,yBAAyB;EACzB,gFAA2E;AAC7E;;AAEA;EACE,sBAAsB;EACtB,8EAAoE;AACtE;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,cAAc;AAChB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,cAAc;;AAEhB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,mDAA+C;EAC/C,wBAAwB;EACxB,4BAA4B;EAC5B,kCAAkC;EAClC,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,UAAU;EACV,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B","sourcesContent":["@font-face {\n  font-family: \"Barlow\";\n  src: local(\"Barlow\"), url(\"../fonts/Barlow-Regular.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"BarlowBold\";\n  src: local(\"BarlowBold\"), url(\"../fonts/Barlow-Medium.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Nelphim\";\n  src: local(\"Nelphim\"), url(\"../fonts/Nelphim.woff2\") format(\"woff2\");\n}\n\n.section-about-group {\n  display: block;\n  max-width: 1366px;\n  padding: 60px 0px;\n  margin-left: auto;\n  margin-right: auto;\n}\n.about-text {\n  width: 100%;\n  display: flex;\n  padding-bottom: 60px;\n}\n.about-text .section-about-1 {\n  width: 65%;\n  padding: 0px 30px 0px 60px;\n}\n.about-text .section-about-2 {\n  width: 35%;\n  padding: 0px 60px 0px 30px;\n}\n.about-img {\n  width: calc(100% - 120px);\n  display: block;\n  padding: 0px 60px 0px 60px;\n  overflow: auto;\n}\n.about-img .about-img-group {\n  width: 100%;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n  overflow: auto;\n}\n.about-img .about-img-group img {\n  width: 100%;\n  border-radius: 30px;\n  margin-bottom: 12px;\n}\n\n@keyframes fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 100;\n  }\n}\n\n.section-vision {\n  background-color: #7ca7c1;\n  width: 100vw;\n  color: #fcfcfc;\n \n}\n.section-vision-group {\n  display: flex;\n  max-width: 1366px;\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  overflow: auto;\n}\n.vision-bg-image {\n  background: url(../images/VisionMissionBG.webp);\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center center;\n  min-height: 60vh;\n  animation: fade-in 5s;\n}\n.section-vision-1 {\n  height: 100%;\n  width: 50%;\n  display: block;\n  text-align: right;\n}\n.section-vision-1 .section-title {\n  margin-top: 90px;\n  padding-right: 180px;\n  text-transform: uppercase;\n}\n.section-vision-2 {\n  width: 50%;\n  display: block;\n}\n.section-vision-2 .section-detail {\n  padding-left: 180px;\n  padding-right: 60px;\n  padding-top: 110px;\n}\n.section-vision-2 .section-button {\n  padding-left: 180px;\n}\n.section-team {\n  padding: 60px 0px;\n}\n.section-team-group {\n  display: block;\n  max-width: 1366px;\n  margin-left: auto;\n  margin-right: auto;\n}\n.section-team-title-group {\n  width: 100%;\n  display: flex;\n  align-items: center;\n}\n.section-team-title-group .section-team-title {\n  width: 50%;\n  padding: 0px 0px 0px 60px;\n}\n.section-team-title-group .section-team-desc {\n  width: 50%;\n  padding: 0px 60px 0px 0px;\n}\n.section-team-image {\n  display: flex;\n  max-width: 1366px;\n  margin-left: auto;\n  margin-right: auto;\n}\n.team-image-group {\n  width: calc(100% - 120px);\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  gap: 20px;\n  overflow: auto;\n  margin-left: auto;\n  margin-right: auto;\n  padding-top: 30px;\n}\n.team-image-group .card {\n  width: 100%;\n  display: block;\n  margin-top: 30px;\n}\n.team-image-group .card .member-img-box {\n  border-radius: 30px;\n  background: #f7f7f7;\n  display: flex;\n  padding: 20px;\n}\n.team-image-group .card .member-img-box .member-img {\n  width: 100%;\n  border-radius: 30px;\n}\n.team-image-group .card .team-member-info {\n  padding: 16px 20px 0px 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
